import { checkPasswordRules } from '@gestao/shared'
import { cn } from '@gestao/ui'
import { Check, Circle } from 'lucide-react'

import * as t from '../../i18n/pt-BR'

interface PasswordRulesProps {
  password: string
  id?: string
}

const RULES = [
  { key: 'minLength', label: t.auth.passwordRules.minLength },
  { key: 'hasLetter', label: t.auth.passwordRules.hasLetter },
  { key: 'hasNumber', label: t.auth.passwordRules.hasNumber },
] as const

/** Lista de requisitos da senha nova, marcada enquanto a pessoa digita. */
export function PasswordRules({ password, id }: PasswordRulesProps) {
  const checks = checkPasswordRules(password)
  return (
    <ul id={id} aria-label={t.auth.passwordRules.label} className="flex flex-col gap-1">
      {RULES.map((rule) => {
        const met = checks[rule.key]
        return (
          <li
            key={rule.key}
            className={cn('flex items-center gap-2 text-compact', met ? 'text-ink' : 'text-ink-2')}
          >
            {met ? (
              <Check aria-hidden className="size-3.5 shrink-0 text-jade" />
            ) : (
              <Circle aria-hidden className="size-3.5 shrink-0 text-ink-2" />
            )}
            <span>{rule.label}</span>
            <span className="sr-only">
              {met ? t.auth.passwordRules.met : t.auth.passwordRules.pending}
            </span>
          </li>
        )
      })}
    </ul>
  )
}
